import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vernost-screen',
  templateUrl: './vernost-screen.html',
  styleUrls: ['./vernost-screen.scss']
})

export class VernostScreenComponent {

  @Input('screentitle') screentitle: string;
  @Input('actionmode') actionmode:string;
  constructor() {

  }

  ngOnInit() {

  }

  @Output() showSearch = new EventEmitter<string>();
  @Output() saveData = new EventEmitter<string>();

  onBackClick() {
    this.showSearch.emit();
  }

  SaveData(){
    this.saveData.emit();
  }

}
